import React from "react";
import "./PuneGoaPackage.css";

const itinerary = [
  {
    day: "Day 1",
    title: "Pune to Goa",
    places: ["Pune", "Goa"],
    note: "Arrival in Goa",
  },
  {
    day: "Day 2",
    title: "North Goa Sightseeing",
    places: [
      "North Goa",
      "Calangute Beach",
      "Baga Beach",
      "Anjuna Beach",
    ],
    note: "North Goa sightseeing",
  },
  {
    day: "Day 3",
    title: "South Goa Sightseeing",
    places: [
      "South Goa",
      "Miramar Beach",
      "Dona Paula",
      "Old Goa",
    ],
    note: "South Goa sightseeing",
  },
  {
    day: "Day 4",
    title: "Goa Local Tour",
    places: [
      "Goa Local",
      "Beach Visit",
      "Local Sightseeing",
    ],
    note: "Explore Goa at your convenience",
  },
  {
    day: "Day 5",
    title: "Goa to Pune",
    places: ["Goa", "Pune"],
    note: "Return journey to Pune",
  },
];

const vehicles = [
  {
    name: "Sedan Cab",
    price: "₹21,999",
    icon: "🚘",
  },
  {
    name: "Ertiga Cab",
    price: "₹26,499",
    icon: "🚙",
  },
  {
    name: "Kia Carens",
    price: "₹30,999",
    icon: "🚗",
  },
  {
    name: "Innova Crysta",
    price: "₹33,999",
    icon: "🚐",
    popular: true,
  },
];

export default function PuneGoaPackage() {
  return (
    <section className="goa-package">
      <div className="goa-container">

        {/* HEADER */}
        <div className="goa-header">

          <div className="goa-logo-box">
            <img
              src="/images/logo.jpg"
              alt="Garud Cabs"
              className="goa-logo"
            />
          </div>

          <div className="goa-header-content">

            <span className="goa-badge">
              5 DAYS • GOA TOUR
            </span>

            <h1>
              Pune to Goa
              <span> 5-Day Tour Package</span>
            </h1>

            <p>
              Enjoy a comfortable 5-day Pune to Goa Commercial Cab tour
              with sightseeing, beach visits and convenient round-trip
              travel with Garud Cabs.
            </p>

          </div>
        </div>


        {/* ROUTE */}
        <div className="goa-route">

          <span className="goa-route-label">
            TOUR ROUTE
          </span>

          <div className="goa-route-text">
            Pune <b>→</b> Goa
            <b> → </b> North Goa
            <b> → </b> South Goa
            <b> → </b> Goa Local
            <b> → </b> Pune
          </div>

        </div>


        {/* MAIN CONTENT */}
        <div className="goa-main-grid">

          {/* ITINERARY */}
          <div className="goa-card">

            <div className="goa-section-heading">

              <div className="goa-heading-number">
                05
              </div>

              <div>
                <small>COMPLETE TOUR PLAN</small>
                <h2>5-Day Goa Itinerary</h2>
              </div>

            </div>


            <div className="goa-timeline">

              {itinerary.map((item, index) => (
                <div
                  className="goa-timeline-item"
                  key={item.day}
                >

                  <div className="goa-day-number">
                    {index + 1}
                  </div>

                  <div className="goa-day-content">

                    <span className="goa-day-label">
                      {item.day}
                    </span>

                    <h3>{item.title}</h3>

                    <div className="goa-places">

                      {item.places.map((place, i) => (
                        <React.Fragment key={place}>

                          <span>{place}</span>

                          {i !== item.places.length - 1 && (
                            <b>→</b>
                          )}

                        </React.Fragment>
                      ))}

                    </div>

                    <div className="goa-day-note">
                      🌴 {item.note}
                    </div>

                  </div>

                </div>
              ))}

            </div>
          </div>


          {/* RIGHT SIDE */}
          <div className="goa-side">

            {/* PACKAGE DETAILS */}
            <div className="goa-card goa-details">

              <span className="goa-mini-label">
                TOUR DETAILS
              </span>

              <h2>Pune to Goa Package</h2>

              <div className="goa-detail-row">
                <span>Starting Point</span>
                <strong>Pune</strong>
              </div>

              <div className="goa-detail-row">
                <span>Destination</span>
                <strong>Goa</strong>
              </div>

              <div className="goa-detail-row">
                <span>Duration</span>
                <strong>5 Days</strong>
              </div>

              <div className="goa-detail-row">
                <span>Tour Coverage</span>
                <strong>North & South Goa</strong>
              </div>

              <div className="goa-detail-row">
                <span>Journey Type</span>
                <strong>Round Trip</strong>
              </div>

              <div className="goa-detail-row">
                <span>Cab Type</span>
                <strong>Commercial Cab</strong>
              </div>

            </div>


            {/* HIGHLIGHTS */}
            <div className="goa-card goa-highlights">

              <span className="goa-mini-label">
                TOUR HIGHLIGHTS
              </span>

              <div className="goa-highlight-grid">

                <div>
                  <span>✓</span>
                  North Goa
                </div>

                <div>
                  <span>✓</span>
                  South Goa
                </div>

                <div>
                  <span>✓</span>
                  Beach Tour
                </div>

                <div>
                  <span>✓</span>
                  Local Sightseeing
                </div>

                <div>
                  <span>✓</span>
                  Commercial Cab
                </div>

                <div>
                  <span>✓</span>
                  Pune Round Trip
                </div>

              </div>

            </div>


            {/* NOTE */}
            <div className="goa-note">

              <strong>
                🏖️ Pune to Goa Road Trip
              </strong>

              <p>
                Explore Goa with a Commercial Cab for your family or group,
                covering popular beaches and sightseeing destinations
                during your 5-day tour.
              </p>

            </div>

          </div>
        </div>


        {/* PRICING */}
        <div className="goa-pricing">

          <div className="goa-pricing-heading">

            <div>

              <span className="goa-mini-label">
                CHOOSE YOUR CAB
              </span>

              <h2>5-Day Goa Package Price</h2>

            </div>

            <p>
              Pune → Goa Tour → Pune
            </p>

          </div>


          <div className="goa-vehicle-grid">

            {vehicles.map((vehicle) => (
              <div
                className={`goa-vehicle-card ${
                  vehicle.popular ? "goa-popular" : ""
                }`}
                key={vehicle.name}
              >

                {vehicle.popular && (
                  <span className="goa-popular-tag">
                    POPULAR
                  </span>
                )}

                <div className="goa-vehicle-icon">
                  {vehicle.icon}
                </div>

                <div className="goa-vehicle-info">
                  <h3>{vehicle.name}</h3>
                  <small>5-Day Tour Package</small>
                </div>

                <div className="goa-price">
                  {vehicle.price}
                </div>

              </div>
            ))}

          </div>

        </div>


        {/* BOOKING CTA */}
        <div className="goa-booking">

          <div>

            <span>
              GARUD CABS • PUNE
            </span>

            <h2>
              Book Your Pune to Goa Tour
            </h2>

            <p>
              5-Day Tour • Commercial Cab • North & South Goa
            </p>

          </div>

          <a
            href="tel:+919970007784"
            className="goa-book-btn"
          >
            Book Your Cab →
          </a>

        </div>

      </div>
    </section>
  );
}